import { Badge } from "@chakra-ui/react";
import { t } from "@lingui/macro";
import { Link } from "@src/components/ui-kit";
import { WrapComponent } from "@src/utils/components/WrapComponent";
import { useInvoiceDetailStore } from "../../../store";
import { Item } from "../../common";
export const PurchaseOrder = () => {
  const store = useInvoiceDetailStore();

  if (!store.invoice?.orders) return null;

  return (
    <div className="mb-6">
      <Item label={t`Purchase order`}>
        <span className="flex space-x-2">
          {store.invoice.orders
            .filter((o) => o.purchase_order_no)
            .map((o) => (
              <span key={o.id}>
                <WrapComponent
                  if={!!o.urls.preview}
                  with={(children) => (
                    <Link href={o.urls.preview!} isExternal>
                      {children}
                    </Link>
                  )}
                >
                  <Badge colorScheme="yellow">{o.purchase_order_no}</Badge>
                </WrapComponent>
              </span>
            ))}
        </span>
      </Item>
    </div>
  );
};
